import * as z from "zustand";
export const useGroupLook = z.create((set) => ({
    look: null,
    setLook: (look) => set({ look: look }),
}));
export const useGroupData = z.create((set) => ({
    data: null,
    setData: (data) => set({ data: data }),
}));
export const useHeroSectionExistance = z.create((set) => ({
    existHeroSection: false,
    setExist: (data) => set({ existHeroSection: data }),
}));
// * =============================== [ GROUP LOOK SELECTORS ]
/** Restituisce l'intero oggetto look, oppure null se non ancora caricato. */
export const getGroupsLook = () => useGroupLook((s) => s.look);
/** Restituisce la funzione per popolare/aggiornare il look nello store. */
export const setGroupsLook = () => useGroupLook((s) => s.setLook);
/** Impostazioni del player (autoplay, controlli, ecc.). Undefined se il look non è caricato. */
export const getPlayersSettings = () => useGroupLook((s) => s.look?.players_settings);
/** Tema del gruppo (colori, dark/light). Undefined se il look non è caricato. */
export const getGroupTheme = () => useGroupLook((s) => s.look?.theme);
/** Loghi del gruppo nelle varie varianti. Undefined se il look non è caricato. */
export const getGroupLogo = () => useGroupLook((s) => s.look?.logo);
/** Ads del gruppo impostate del superAdmin. Undefined se data non è caricato. */
export const getGroupAds = () => useGroupData((s) => s.data?.ads_data);
export const getFillerGif = () => useGroupData((s) => s.data?.filler_gif);
